import { Injectable } from '@angular/core';
import { FormExtractorService } from '../../../../../shared/services/form-extractor.service';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { TypeCPVClassFNSSimple } from '../../models/TypeCPVClassFNSSimple';
import { TypeFNSSimpleDescMarche2 } from '../../models/TypeFNSSimpleDescMarche2';
import { TypeNatureMarcheChoix } from '../../models/TypeNatureMarcheChoix';
import { TypeObjCPVFNSSimple } from '../../models/TypeObjCPVFNSSimple';
import { SimpATControlNames } from '../../simpATControleNames';
import { AvisDataTransferService } from '../../../../../shared/services/avis-data-transfer.service';

@Injectable({
	providedIn: 'root',
})
export class NatureMarcheService {
	constructor(private avisDataTransferService: AvisDataTransferService) { }

	public getNatureMarche(controls: any, stepId): TypeFNSSimpleDescMarche2 {
		const natureMarche = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.fnSimple.attribution.natureMarche;

		if (stepId === 4) {
			natureMarche.description = controls.get('_SepSep_AttributionFromFNSimple_SepSep_TypeFNSSimpleDescMarche2_SepAtt_description');
			natureMarche.intitule = controls.get('_SepSep_AttributionFromFNSimple_SepSep_TypeFNSSimpleDescMarche2_SepAtt_intitule');
			
			natureMarche.codeCPV = new TypeObjCPVFNSSimple();
			natureMarche.codeCPV.objetPrincipal = new TypeCPVClassFNSSimple();
			natureMarche.codeCPV.objetPrincipal.classPrincipale = controls.get('_SepSep_AttributionFromFNSimple_SepSep_TypeFNSSimpleDescMarche2_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale');

			natureMarche.natureMarche = new TypeNatureMarcheChoix();
			natureMarche.natureMarche.travaux = controls.get('_SepSep_AttributionFromFNSimple_SepSep_TypeFNSSimpleDescMarche2_SepSep_TypeNatureMarcheChoix_SepAtt_travaux') === RadioCheckBoxEnum.travauxValue ? RadioCheckBoxEnum.emptyValue : null;
			natureMarche.natureMarche.fournitures = controls.get('_SepSep_AttributionFromFNSimple_SepSep_TypeFNSSimpleDescMarche2_SepSep_TypeNatureMarcheChoix_SepAtt_travaux') === RadioCheckBoxEnum.fournituresValue ? RadioCheckBoxEnum.emptyValue : null;
			natureMarche.natureMarche.services = controls.get('_SepSep_AttributionFromFNSimple_SepSep_TypeFNSSimpleDescMarche2_SepSep_TypeNatureMarcheChoix_SepAtt_travaux') === RadioCheckBoxEnum.servicesValue ? RadioCheckBoxEnum.emptyValue : null;
		}
		if (stepId === 3) {
			natureMarche.criteresAttrib = controls.get('_SepSep_AttributionFromFNSimple_SepSep_TypeFNSSimpleDescMarche2_SepAtt_criteresAttrib');
		}
		
		return natureMarche;
	}
}
